/*
 Formularz
 wykorzystano bibliotekę Formik
 
 historia:
  2019-04-19 (JW): pierwsza wersja na podstawie formularza Smarty
*/
// https://bit.dev/mui-org/material-ui/dialog-content
// https://material-ui.com/api/dialog/
// https://material-ui.com/demos/buttons/
//
import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from "@material-ui/core/DialogContentText";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles, Theme, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';

import { Formik, Form, FormikProps, FormikTouched, FormikErrors } from 'formik';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import { connect, Provider } from 'react-redux';

import NotifierOptions from '../unused/DialogRemarks';

import PrefixPicker, { getPrefix } from '../common/PrefixPicker';
import { FieldTypes, FormFields, renderFields } from '../common/formFields/renderFields';
import { PoleDlugosciJednoWWierszu, mobileBreakpoint } from '../common/formFields/formularzStaleWspolne';
import { FormikTextFieldProps } from '../common/formFields/FormikTextField';

import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from '@date-io/date-fns';

import NoteIcon from '@material-ui/icons/Note';

import theme from '../../themes/themes';
import themeBlue from '../../themes/themesBlue';
import themeGreen from '../../themes/themesGreen';
import themeBrownLight from '../../themes/themesBrownLight';
import themeBrownDark from '../../themes/themesBrownDark';

import { AppState, Actions, store, Values, ZapisanyFormularz, IPageState } from '../../appredux';

import { obiektService, PokojOpcja, Rezerwacja, Pobyt, RezerwacjaPobyt } from '../../api';

import { FormularzLabels, FormikFieldNames } from './formularzStale';

import DialogInfo from '../common/DialogInfo';
import { Content } from '../Notifier';
import { setLocale } from '../common/localeHelpers';
import { Avatar, Box, Checkbox, SvgIcon, TextField } from '@material-ui/core';
import DividerTypography from '../common/DividerTypography';
import AppRegistrationRoundedIcon from '@mui/icons-material/AppRegistrationRounded';
import { daysFromDate, sendErrorLog } from '../common/helpers';
import CONFIG from '../../cfg/config';
import ReactDOM from 'react-dom';
import Klawiatura from 'app/common/Klawiatura';

//PM 2021-11-30
type ConfirmDialogProps = {
  page: IPageState,

  secondaryLight: string,
  secondaryText: string,
  lang: string,
  czyPobytZmieniany: boolean,
  zmienianyPobyt: RezerwacjaPobyt,
  initialValues: Values,
  theme: string,
  zapisanyFormularz: ZapisanyFormularz,
  formularzPicture: string,
  dateFrom: string,

  width: number,
  panel: number,
  options: PokojOpcja[],
  //onChangeRemarks: (e: React.ChangeEvent<{ name?: string; value: any }>) => void,
  onChangeRemarks: (value: string) => void,
  remarks: string,
  checked: string[],
  changeChecked: (event: React.ChangeEvent<HTMLInputElement>) => void,
}


type ConfirmDialogState = {
  remarksColor: boolean,
  //table: dostepnoscPokoju[],
  //vacantRooms: number,
  //checked: string[],
}

let stylInputa: React.CSSProperties = { padding: "8px 14px", fontWeight: "normal", textAlign: "left" };
class ConfirmDialog extends React.Component<WithTranslation & ConfirmDialogProps & WithStyles<typeof styles>, ConfirmDialogState> {
  secondaryLight = this.props.secondaryLight;
  textSecondary = this.props.secondaryText;

  disabledAll: boolean

  constructor(props: WithTranslation & ConfirmDialogProps & WithStyles<typeof styles>) {
    super(props, {});
    this.state = {
      remarksColor: false
      
      //checked: this.checkedValues(),
    }
    this.disabledAll = CONFIG.menu1PobytZmien === "2" && props.czyPobytZmieniany
    //console.log(this.props.page.dateFromFormularz)
  }

  // checkedValues = () => {
  //   let checked: string[] = [];

  //   for (let i = 0; i < this.props.options.length; i++) {
  //     checked.push("0")
  //   }

  //   if (this.props.czyPobytZmieniany) {
  //     checked[2 - 1] = this.props.zmienianyPobyt.tagUwagi02;
  //     checked[3 - 1] = this.props.zmienianyPobyt.tagUwagi03;
  //     checked[4 - 1] = this.props.zmienianyPobyt.tagUwagi04;
  //     checked[5 - 1] = this.props.zmienianyPobyt.tagUwagi05;
  //     checked[6 - 1] = this.props.zmienianyPobyt.tagUwagi06;
  //     checked[7 - 1] = this.props.zmienianyPobyt.tagUwagi07;
  //     checked[8 - 1] = this.props.zmienianyPobyt.tagUwagi08;
  //     checked[9 - 1] = this.props.zmienianyPobyt.tagUwagi09;
  //     checked[11 - 1] = this.props.zmienianyPobyt.tagUwagi11;
  //     checked[12 - 1] = this.props.zmienianyPobyt.tagUwagi12;
  //     checked[13 - 1] = this.props.zmienianyPobyt.tagUwagi13;
  //     checked[14 - 1] = this.props.zmienianyPobyt.tagUwagi14;
  //     store.dispatch(Actions.pageState.setOptionsValues(checked));
  //   }

  //   return checked;
  // }

  //PM 2021-11-24
  componentDidMount = async () => {
    
  }

  async componentDidUpdate(prevProps: ConfirmDialogProps) {
    if (this.props.panel !== prevProps.panel) {
      this.setState({
        remarksColor: false,
      });
    };
  }

  // change = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   let val = "0"
  //   //event.target.checked ? val = "1" : "0"
  //   let checked = this.state.checked
  //   checked[parseInt(event.target.id)] = val
  //   this.setState({
  //     ...this.state,
  //     checked: checked
  //   });
  // }

  // change = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const val = event.target.checked ? "1" : "0"
  //   let checked = this.state.checked
  //   checked[parseInt(event.target.id)] = val
  //   this.setState({
  //     ...this.state,
  //     checked: checked
  //   });
  // }

   //oblicza na ile lini w inpucie textarea jest miejsca
   calculateRows = (ileCheckboxow: number) => {
    const wysokoscCheckboxow = 42 * Math.ceil(this.props.width <= 1280 ? ileCheckboxow / 2 : ileCheckboxow / 3);
    const dostepnaWysokosc = window.innerHeight - 550 - wysokoscCheckboxow;
    const rows = String(Math.floor(dostepnaWysokosc / 19))
    //return Number(rows) < 5 ? "5" : rows;
    return "13" 
  }

  onChangeRemarks = (event: React.ChangeEvent<{ name?: string; value: any }>) => { 
    this.props.onChangeRemarks(event.target.value)
    this.setState({remarksColor: true })
}

openKlawiaturaRemarks = (val: string,  setFieldValue: ( value: string) => void) => {
  const { t, classes } = this.props;
  ReactDOM.render(
      <Provider store={store}>
          <MuiThemeProvider theme={theme}>
              <Klawiatura  randomNum={Math.random()} val={val} type={"default"} placeholder={t('Info')} onConfirm={(val: string) => {setFieldValue(val);this.setState({remarksColor: true })} } /> 
          </MuiThemeProvider>
      </Provider>, document.getElementById("dialogKlawiatura"))
}

  //PM 2021-11-22
  render() {
    const { t, classes } = this.props;

    let checkboxList: JSX.Element[] = [];
    for (let i = 0; i < this.props.options.length; i++) {
      if (this.props.options[i].aktywna === "1"){
        checkboxList.push(
          <FormControl color="primary"
            key={this.props.options[i].opis} margin="normal"
            style={{
              display: 'inline-block', paddingRight: "15px",
              width: "165px", marginTop: "8px", marginBottom: 0
            }}>
            <Checkbox color="primary"
              checked={this.props.checked[i] === "1" ? true : false}
              onChange={this.props.changeChecked}
              id={String(i)}
              //className={classes.secondary}
              inputProps={{ 'aria-label': 'secondary checkbox' }}
              disabled={this.disabledAll}
            />
            <label className={classes.label} style={{ display: "inline" }}>{this.props.options[i].opis === "" ? "przykładowy opis" : this.props.options[i].opis}</label>
          </FormControl>
        )
      }                       ///  wyświetlanie tylko aktywnych checkboxów
        
    }

    return (
     <>      
                
          <FormControl fullWidth style={{ display: 'block', marginBottom: "0", width: this.props.width <= 1280 ? "363.5px" : "545.25px" }}>
            {checkboxList}
          </FormControl>
          {/* <br /> */}
          <Typography gutterBottom component="h6"
            className={`${classes.primary} ${classes.headline}`} style={{ paddingBottom: "5px", marginTop: "15px", paddingLeft: "8px" }}><Trans>Info</Trans></Typography>
          <FormControl
            margin="normal" fullWidth
            style={{ display: 'block', paddingBottom: "35px", marginTop: "8px" }}
          //onFocus={() => setInterval(() => this.zmienTlo("44"), 500)}
          >
            <TextField 
              name="remarks" style={{ float: 'left', width: '97%', marginBottom: "4px" }}
              className={classes.textField} multiline rows={this.calculateRows(checkboxList.length)}
              variant="outlined"
              inputProps={{
                //style: this.props.remarks !== ''
                style: this.state.remarksColor ?
                   { ...stylInputa, backgroundColor: this.secondaryLight } : stylInputa
              }}
              InputProps={{ classes: { input: `${classes.black}` } }} autoFocus
              onChange={this.onChangeRemarks}
              onClick= {CONFIG.hotelKiosk === "1" ? () => this.openKlawiaturaRemarks(this.props.remarks, this.props.onChangeRemarks) : ()=>{}}
              value={this.props.remarks}
              disabled={this.disabledAll}
            />
          </FormControl>
                         
      </>
    );
  }
}

//??export default withMobileDialog()(ConfirmDialog);
const styles = (theme: Theme) => ({
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "0px"
  },
  textField: {
    marginLeft: "6px",
    //marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  black: {
    //color: "rgb(0, 0, 0)",
    //color: theme.palette.text.secondary,
    color: theme.palette.primary.main,
    backgroundColor: "inherit",
    textAlign: 'left' as 'left',
  },
  actionButtons: {
    textTransform: "lowercase" as "lowercase"
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  label: {
    //fontFamilly: "sans-serif",
    //fontSize: "small"
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight,
    padding: "7px 0 4px",
    color: theme.palette.primary.main,
  },
  primary: {
    color: theme.palette.primary.main
  },
  secondary: {
    color: theme.palette.secondary.main
  },
  textSecondary: {
    color: theme.palette.text.secondary
  },
  text: {
    fontSize: "1.07rem"
  },
  floatLeft: {
    float: "left" as "left"
  },
  floatRight: {
    float: "right" as "right"
  },
  textAlignLeft: {
    textAlign: "left" as "left",
  },
  fontWeightNormal: {
    fontWeight: "normal" as "normal"
  },
  button: {
    height: "35px",
  },
  backgroundWhite: {
    backgroundColor: "#ffffff"
  },
  dialogContent: {
    maxWidth: "1141px",
    minWidth: "368px",
    paddingLeft: "12px",
    paddingRight: "24px",
    paddingBottom: "8px"
  },
  spanOuter: {
    maxWidth: "552px",
    minWidth: "350px",
    width: "100%"
  },
  spanOuterLeft: {
    backgroundColor: "#f9f9f9",
    paddingLeft: "12px"
  },
  legend: {
    padding: "35px 8px 35px 0px"
  },
  dialogPaper: {
    maxHeight: "100%",
    maxWidth: "1177px",
    minWidth: "350px",
  },
  inputPhone: {
    padding: "8px 14px 8px 75px",
    marginLeft: "-71px",
  },
  uppercase: {
    textTransform: "uppercase" as "uppercase",
  },
  formControl: {
    display: "block",
  },
  icon: {
    width: "24px",
    height: "24px"
  },
  transformNone: {
    textTransform: 'none' as 'none'
  },
  textCenter: {
    textAlign: 'center' as 'center'
  },
  marginDivider: {
    marginTop: '7.5px'
  },
  marginWpisz: {
    marginTop: '10.5px'
  },
  avatar: {
    marginTop: '8px',
    marginBottom: '16px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  justifyStart: {
    justifyContent: 'flex-start'
  },
  marginProvider: {
    marginBottom: '10px'
  },
  registrationIcon: {
    width: '24px !important',
    height: '24px !important'
  }
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
  secondaryLight: state.pageState.secondaryLight,
  secondaryText: state.pageState.secondaryText,
  lang: state.pageState.lang,
  czyPobytZmieniany: state.pageState.czyPobytZmieniany,
  zmienianyPobyt: state.pageState.zmienianyPobyt,
  initialValues: state.pageState.initialValues,
  theme: state.pageState.theme,
  zapisanyFormularz: state.pageState.zapisanyFormularz,
  formularzPicture: state.pageState.formularzPicture,
  dateFrom: state.pageState.dateFrom,
  options: state.pageState.options,
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(ConfirmDialog)));